import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageTopicGeek({ topicID, axiosConfigs = {} }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopicGeek(data = {}) {
    return privateFetch.post(`/v1/admin/topic/${topicID}/geekcorner`, data, axiosConfigs);
  }

  function updateTopicGeek(data = {}) {
    return privateFetch.put(`/v1/admin/topic/${topicID}/geekcorner`, data, axiosConfigs);
  }

  function deleteTopicGeek({ geekID } = {}) {
    return privateFetch.delete(`/v1/admin/topic/${topicID}/geekcorner/${geekID}`, axiosConfigs);
  }

  function reOrderTopicStory(data = {}) {
    return privateFetch.patch(`/v1/admin/content/geekcorner/reorder`, data, axiosConfigs);
  }

  function manageTopicsSections({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateTopicGeek(data);
    }

    if (type === 'DELETE') {
      return deleteTopicGeek(data);
    }

    if (type === 'REORDER') {
      return reOrderTopicStory(data);
    }

    return addTopicGeek(data);
  }

  return useMutation(manageTopicsSections, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useManageTopicGeek;
